import { useContent } from "../../i18n";
import { MoneyDemo } from "../Demos/MoneyDemo";
import { RequestDemo } from "../Demos/RequestDemo";
import "./style.scss";

export const Providers = () => {
  const { providers, demos } = useContent();

  return (
    <div id="providers" className="providers-wrapper">
      <div className="container">
        <h2>{providers.title}</h2>
        <p className="section-intro">{providers.intro}</p>

        <div className="compare">
          <div className="compare-col before">
            <h3>{providers.beforeTitle}</h3>
            <ol>
              {providers.before.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </div>
          <div className="compare-col after">
            <h3>{providers.afterTitle}</h3>
            <ol>
              {providers.after.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </div>
        </div>

        <p className="journey-link">
          <a href="/journey.html">{providers.journeyLink}</a>
        </p>

        <h3 className="sub-title">{demos.request.title}</h3>
        <p className="sub-intro">{demos.request.intro}</p>
        <RequestDemo />

        <h3 className="sub-title">{providers.benefitsTitle}</h3>
        <div className="info-grid three">
          {providers.benefits.map((item) => (
            <div className="info-card" key={item.t}>
              <h4>{item.t}</h4>
              <p>{item.d}</p>
            </div>
          ))}
        </div>

        <h3 className="sub-title">{providers.modelsTitle}</h3>
        <p className="sub-intro">{providers.modelsIntro}</p>
        <div className="info-grid three">
          {providers.models.map((item) => (
            <div className="info-card model" key={item.t}>
              <h4>{item.t}</h4>
              <p>{item.d}</p>
            </div>
          ))}
        </div>

        <h3 className="sub-title">{demos.money.title}</h3>
        <p className="sub-intro">{demos.money.intro}</p>
        <MoneyDemo />

        <h3 className="sub-title">{providers.submitTitle}</h3>
        <div className="info-grid three">
          {providers.submit.map((item, i) => (
            <div className="info-card stage" key={item.t}>
              <span className={i === 0 ? "stage-tag now" : "stage-tag"}>
                {item.tag}
              </span>
              <h4>{item.t}</h4>
              <p>{item.d}</p>
            </div>
          ))}
        </div>

        <p className="journey-link">
          <a href="/meeting.html">{providers.meetingLink}</a>
        </p>

        <div className="section-cta">
          <a className="cta-button" href="#contact">
            {providers.cta}
          </a>
        </div>
      </div>
    </div>
  );
};
